import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from "../services/general/index";

@Injectable({ providedIn: 'root' })
export class AuthorizationGuard implements CanActivate {

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    return this.authenticationService
      .isAuthorized()
      .pipe(
        map(v => {
          if (v && v.isAuthenticated) {
            return true;
          }
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
          return false;
        }
        ));
  }
}
